module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "login-section"
  }, [_c('b-loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _c('div', {
    staticClass: "login-wrapper columns is-desktop",
    class: {
      'is-hom': _vm.isHom
    }
  }, [_c('div', {
    staticClass: "column is-6-desktop is-11-tablet"
  }, [_c('section', {
    staticClass: "hero is-fullheight"
  }, [_vm._m(0), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-2 has-text-centered section"
  }, [_vm._v("Autenticação")]), (_vm.isHom) ? _c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "subtitle is-5 has-text-centered"
  }, [_vm._v("HOMOLOGAÇÃO")])]) : _vm._e(), _c('form', {
    staticClass: "login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments)
      }
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Email ou Nome de Usuário",
      "message": _vm.errors.first('username'),
      "type": _vm.isDanger('username')
    }
  }, [_c('b-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validations.username),
      expression: "validations.username"
    }],
    staticClass: "email-input",
    attrs: {
      "type": "text",
      "icon": "person",
      "name": "username",
      "data-vv-as": "Email ou Nome de Usuário"
    },
    model: {
      value: (_vm.credentials.username),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "username", $$v)
      },
      expression: "credentials.username"
    }
  })], 1), _c('b-field', {
    attrs: {
      "label": "Senha",
      "message": _vm.errors.first('password'),
      "type": _vm.isDanger('password')
    }
  }, [_c('b-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validations.password),
      expression: "validations.password"
    }],
    staticClass: "password-input",
    attrs: {
      "type": "password",
      "icon": "lock",
      "password-reveal": "password-reveal",
      "name": "password",
      "data-vv-as": "senha"
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "password", $$v)
      },
      expression: "credentials.password"
    }
  })], 1), _vm._m(1)], 1), _c('div', {
    staticClass: "section forgot-password"
  }, [_c('p', {
    staticClass: "has-text-centered"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.forgotPasswordModalActive = true
      }
    }
  }, [_vm._v("Esqueci a Senha")]), _c('a', {
    on: {
      "click": function($event) {
        _vm.helpModalActive = true
      }
    }
  }, [_vm._v("Ajuda")])]), _c('b-modal', {
    attrs: {
      "active": _vm.helpModalActive,
      "has-modal-card": "has-modal-card"
    },
    on: {
      "update:active": function($event) {
        _vm.helpModalActive = $event
      }
    }
  }, [_c('help-modal')], 1), _c('b-modal', {
    attrs: {
      "active": _vm.forgotPasswordModalActive,
      "has-modal-card": "has-modal-card"
    },
    on: {
      "update:active": function($event) {
        _vm.forgotPasswordModalActive = $event
      }
    }
  }, [_c('forgot-password-modal')], 1), _c('b-modal', {
    attrs: {
      "active": _vm.resetPasswordModalActive,
      "has-modal-card": "has-modal-card"
    },
    on: {
      "update:active": function($event) {
        _vm.resetPasswordModalActive = $event
      }
    }
  }, [_c('reset-password-modal', {
    attrs: {
      "token": _vm.routeParams.token
    }
  })], 1)], 1)])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-heading"
  }, [_c('div', {
    staticClass: "section has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/logo.png"),
      "alt": "Logo",
      "width": "70%"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control login"
  }, [_c('button', {
    staticClass: "button is-primary is-large",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Login")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ae989d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/Auth.vue
// module id = 397
// module chunks = 56